import React from 'react';
import { ClockIcon, CreditCardIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { useCountdown } from '../hooks/useCountdown';
import { offer } from '../data/offer';
export function FinalCta() {
  const {
    hours,
    minutes,
    seconds,
    expired
  } = useCountdown(23.75);
  return <section id="offer" aria-labelledby="offer-heading" className="bg-navy-950" data-id="element-48" data-mp="15ckjkv8vocby">
      <div className="mx-auto max-w-content px-4 py-20 sm:px-6 lg:py-28" style={{
      paddingTop: "30px",
      paddingBottom: "30px"
    }} data-id="element-49" data-mp="1jcd58c5js2d2">
        <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="1ebxvdukh5czu">
          <h2 id="offer-heading" className="font-display text-[2.15rem] font-extrabold leading-[1.03] tracking-tight text-white sm:text-5xl" data-id="element-51" data-mp="1t1wpnm8ws4a1">
            গরিব থাকা বন্ধ করে সত্যিকারের সম্পদ গড়া শুরু করতে প্রস্তুত?
          </h2>
          <p className="mt-5 text-lg text-white/70" data-id="element-52" data-mp="223w88izkngf3">
            ইতিমধ্যেই নিজেদের জীবন বদলে ফেলছেন এমন {offer.studentCount} উচ্চাকাঙ্ক্ষী বাংলাদেশি
            তরুণের সাথে যোগ দিন।
          </p>

          <div className="mt-10 flex flex-wrap items-baseline justify-center gap-x-4 gap-y-2" data-id="element-53" data-mp="n75qg3w08z8x">
            <span className="font-display text-5xl font-extrabold tabular-nums text-white" data-id="element-54" data-mp="s57fd5g43ssb">
              {offer.priceToday}
            </span>
            <span className="text-xl text-white/40 line-through" data-id="element-55" data-mp="122lm2dc8h37f">
              {offer.priceTomorrow}
            </span>
            <span className="text-sm text-celeste-300" data-id="element-56" data-mp="1658ikrjuncay">
              একবারের পেমেন্ট · ৬টি ভলিউম + ৫টি বোনাস · লাইফটাইম অ্যাক্সেস — ১০০% সিকিউর চেকআউট — সাথে সাথেই ডিজিটাল ডাউনলোড
            </span>
          </div>

          <div className="mt-8 flex flex-col items-center" data-id="element-57" data-mp="1fvl00awdapcv">
            <CtaButton size="lg" href={offer.checkoutUrl} label={<>হ্যাঁ! আমি দ্য আর্জেন্টাইন মাইন্ডসেট চাই 🏆 মাত্র <span className="text-[1.35em] font-extrabold" data-id="element-59" data-mp="1psppajlif0xw">14</span> USD-তে</>} sublabel={`সাথে সাথেই অ্যাক্সেস · ৭ দিনের গ্যারান্টি · ${offer.studentCount} শিক্ষার্থীর সাথে যোগ দিন`} data-id="element-58" data-mp="1kt3cgb9lfmpm" />
          </div>

          <div className="mx-auto mt-10 max-w-xl rounded-xl border border-white/10 bg-navy-900 px-6 py-5" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-60" data-mp="3qu5p05j9njo1">
            <p className="flex flex-wrap items-center justify-center gap-2 text-sm text-white/75" data-id="element-61" data-mp="3hl8pgbcmugu">
              <ClockIcon className="h-4 w-4 text-sun" aria-hidden="true" data-id="element-62" data-mp="3uwityrq6vdjr" />
              {expired ? <span data-id="element-63" data-mp="3uufsnbjl5xzq">
                  এই বিশেষ মূল্য শেষ হচ্ছে{' '}
                  <span className="font-semibold text-white" data-id="element-64" data-mp="ddxy41zv2m5s">আজই</span>
                </span> : <>
                  এই বিশেষ মূল্য শেষ হচ্ছে
                  <span className="font-display font-bold tabular-nums text-white" data-id="element-65" data-mp="mg76al7nq3g0">
                    {hours}:{minutes}:{seconds}
                  </span>
                  পরে
                </>}
            </p>
            <p className="mt-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/50" data-id="element-66" data-mp="2o7akfkgra05b">
              <span className="flex items-center gap-1.5" data-id="element-67" data-mp="2k7a7635e7uzu">
                <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-68" data-mp="2a2a87pqj1jgf" />
                ১০০% সিকিউর পেমেন্ট
              </span>
              <span className="flex items-center gap-1.5" data-id="element-69" data-mp="2e459iu8gjwu7">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-70" data-mp="2e5q6eqi8vrv8" />
                আপনার তথ্য সুরক্ষিত
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}